<template lang="pug">
  v-app-bar( dense app clippedLeft)
    v-app-bar-nav-icon( text @click="toggleAppDrawer")
      v-icon fas fa-bars
    v-toolbar-title.app-title {{ $t('toolbarPage.appTitle') }}
    v-spacer
    v-toolbar-items
      v-menu(v-model="showMenu" offset-y :close-on-content-click="false")
        template(v-slot:activator="{ on, attrs }")
          v-btn.no-background-hover.text--secondary(
            :class="{'pr-0': !$vuetify.breakpoint.xs, 'pl-2': !$vuetify.breakpoint.xs, 'pl-4': $vuetify.breakpoint.xs}"
            :large="$vuetify.breakpoint.xs"
            :text="!$vuetify.breakpoint.xs"
            :icon="$vuetify.breakpoint.xs"
            v-bind="attrs"
            v-on="on"
            :ripple="false")
            v-icon.d-flex.d-sm-none(medium) fa-user-circle
            v-icon.d-none.d-sm-flex(left) fa-user-circle
            span.d-none.d-sm-flex {{userLoggedIn.fullName}}
        user-drop-down(@closeMenu="closeMenu")
  //v-app-bar( dense app clippedLeft)
    v-app-bar-nav-icon( text @click="toggleAppDrawer" )
      v-icon fas fa-bars
    v-toolbar-title.app-title {{ $t('toolbarPage.appTitle') }}

    v-spacer
    v-toolbar-items.toolbar
      user-drop-down

</template>

<script lang="ts">
/*
v-app-bar-nav-icon( text @click="toggleAppDrawer" )
v-icon fas fa-bars
v-toolbar-title.app-title {{ $t('toolbarPage.appTitle') }}

v-spacer
*/

import Vue from 'vue'
import {GET_KEY, TOGGLE_APP_DRAWER} from '@/store/action-types'
import UserDropDown from '@/components/user/UserDropDown.vue'
import {CurrentUser} from "@/model/CurrentUser";
import {USER_LOGGED_IN} from "@/store/getter-types";

interface ComponentData {
  showMenu: boolean,
}

export default Vue.extend({
  name: 'AppToolbar',
  components: {
    UserDropDown
  },
  computed: {
    userLoggedIn(): CurrentUser{
      return this.$store.getters[USER_LOGGED_IN]
    },

  },

  methods: {
    toggleAppDrawer () {
      this.$store.dispatch(TOGGLE_APP_DRAWER)
    },

    closeMenu (): void {
      this.showMenu = false
    },

  },
  data (): ComponentData {
    return {
      showMenu: false
    }
  }
})
</script>

<style lang="stylus" scoped>
.timer
  color red

.app-title
  color var(--v-primary-base)

.no-background-hover::before
  background-color: transparent !important

.toolbar-style
  >>> .v-toolbar__content{
    padding-right 0px
  }


</style>
